/*@ngInject*/
const FilterRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteFilter = function (filterUri) {
        let url = '/rest/Filter',
            config = {
                params: {
                    filterUri: filterUri
                }
            };
        return this.delete(url, config);
    };

    this.saveFilter = function (filter) {
        let url = '/rest/Filter/';
        return this.post(url, filter);
    };

    this.getFilters = function (type) {
        let url = '/rest/Filter',
            config = {
                params: {
                    type: type
                }
            };

        return this.get(url, config);
    };

    this.getFilter = function (filterUri) {
        let url = '/rest/Filter/single',
            config = {
                params: {
                    filterUri: filterUri
                }
            };
        return this.get(url, config);
    };

    this.getFilterTemplates = function (templateId) {
        let url = '/rest/FilterTemplate/' + templateId;
        return this.get(url);
    };
};

angular.module('umCore')
    .service('filterRepository', FilterRepository);
